import { AdminItemConfigurationPageTabs } from './constants';

export enum AdminItemType {
  Project = 'project',
  Product = 'product',
}

export type AdminItemConfigurationPageTab =
  (typeof AdminItemConfigurationPageTabs)[keyof typeof AdminItemConfigurationPageTabs];
